import React, { useState } from 'react';
import '../styles/UserCredentialsModal.css';

function UserCredentialsModal({ user, onClose }) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const credentialsText = `
Brugeroplysninger:
Email: ${user.email}
Midlertidigt password: ${user.tempPassword}

Bemærk: Dette password skal ændres ved første login.
`;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Ny Bruger Oprettet</h2>
        <div className="credentials-box">
          <div className="credential-item">
            <label>Email:</label>
            <div className="copy-field">
              <input type="text" value={user.email} readOnly />
              <button onClick={() => copyToClipboard(user.email)} className="copy-button">
                <i className="fas fa-copy"></i>
              </button>
            </div>
          </div>
          
          <div className="credential-item">
            <label>Midlertidigt Password:</label>
            <div className="copy-field">
              <input type="text" value={user.tempPassword} readOnly />
              <button onClick={() => copyToClipboard(user.tempPassword)} className="copy-button">
                <i className="fas fa-copy"></i>
              </button>
            </div>
          </div>

          <div className="copy-all">
            <button onClick={() => copyToClipboard(credentialsText)} className="copy-all-button">
              Kopier Alle Oplysninger
              <i className="fas fa-copy"></i>
            </button>
            {copied && <span className="copied-message">Kopieret!</span>}
          </div>

          <p className="warning-text">
            OBS: Gem disse oplysninger sikkert. De vises kun én gang.
          </p>
        </div>
        
        <div className="modal-actions">
          <button onClick={onClose} className="close-button">Luk</button>
        </div>
      </div>
    </div>
  );
}

export default UserCredentialsModal; 